/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit } from '@angular/core';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import {FormBuilder, FormGroup} from "@angular/forms";

declare var $ : any;
declare var Swal : any;

@Component({
    selector : 'external-link-modal',
    templateUrl:'external-link-modal.html',
    providers  : [],
})
export class ExternalLinkModal implements OnInit {
  public name;
  public link;
  public key;
  public description='';
  public timer;
  public editable;
  public size;
  public linkForm;
    public ngOnInit() : any {
    }
    public checkSkills(){
      //check if user has recorded skills
      if (!this._appData.userEventSkills){
        this._companyService.getUserSkills()
      }
  }
  public saveLink(){
    let link=this.linkForm.controls['actionLink'].value;
    let id=this._appData.param.id;
    let param;
    for (let i=0;i<this._appData.room.roomObjects.length;i++){
      let obj=this._appData.room.roomObjects[i]
      if (obj.objectId==id){
        this._appData.room.roomObjects[i].param.link=link;
        param=this._appData.room.roomObjects[i].param;
      }
    }
    this._companyService.updateRoom(this._appData.room);
    this.link=link;
    this.sendIframeMessage({
      kind:'updateObjectParams',
      param:{objectId:id,param:param}
    });  

  }
  public sendIframeMessage(messageKind){
    var iframe = document.getElementById('gameFrame');
    if (iframe == null) return;
    var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
    iWindow.postMessage(messageKind, "*");
}
public toggleSize(){

  this.size=!this.size;
  if (this.size){
    this.bigScreen();
  }
  else{
    this.smallScreen();
  }
}
public bigScreen(){
  $('#external-link-dialog').css({'max-width':'100%','width':'100%','height':'100%'})
  $('#externalLinkModal').css({'height': '100%','position': 'absolute','padding-left':'0px','top': '0px','width': '100%'})
}
public smallScreen(){
  $('#external-link-dialog').css({'height':'100%'})
  $('#externalLinkModal').css({'height': '80%'})
}

  public change() {

      let link=this._appData.param.link;
      if (link.indexOf('{uid}')){
        link=link.replaceAll('{uid}',this._appData.instagramUser.uid);
      }

      this.link=link
      this.name=this._appData.param.name
      this.key=this._appData.param.key
      


/*      this.checkSkills();
      this.editable=false;
      this.smallScreen()

      if (this.key){
        if (this.key==this._appData.instagramUser.uid){
          this.editable=true;
        }
        else{
          this._appData.userEventContainer.forEach(element => {
            if (element.id==this.key){
              this.editable=true;
            }
          });
        }
        if (this.editable=true){
          this.linkForm=this.fb.group(       
            {
              actionLink : this.link
            }       
          ); 
        }
  
  
      }*/
     /* let int=null
      if (this._appData.object){
        if (this._appData.object.timeInSeconds){
          this.timer=this._appData.object.timeInSeconds;
          int=setInterval(()=>{
            this.timer=this.timer-1;
            this.description='Você precisa assistir o vídeo por '+this.timer+' segundos para completar este trabalho.'
            if (this.timer<=0){
              clearTimeout(int);
              $('#externalLinkModal').modal('hide'); 
//              this._walletService.updateUserSkill(this._appData.object)
              this._appData.object=null;

              /*.subscribe(val=>{

                let response=val
                let data=JSON.parse(response['_body'])
                Swal.fire({title:'Trabalho terminado',text:'Com seu esforço você obteve '+data['itens']+' itens de '+this._appData.object.name+' e seu talento de '+this._appData.object.skill.name+ ' evoluiu em '+data['skill']+' pontos'})
              })*/
       /*     }

          },1000);
        }
      }
      $('#externalLinkModal').on('hidden.bs.modal',  () =>{
        // do something…
        if (int) {clearTimeout(int);}

        this._appData.param.link='https://liveparty.com.br/iframeBase.html'
        this.link='https://liveparty.com.br/iframeBase.html'

      })

      let idx=this.link.indexOf('https://drive.google.com/drive/folders/')
      if (idx>=0){
        let text=this.link.substring(39)
        var variable2=text.substring(0,33)
        this.link='https://drive.google.com/embeddedfolderview?id='+variable2+'#list' 
      }*/

    }
    public close(){
      this._appData.target={x:this._appData.instagramUser.position.x,y:this._appData.instagramUser.position.y}
      this._appData.stream='';
      $('#youtubeReload').click();

/*      this._appData.param.link='https://liveparty.com.br/iframeBase.html'
      this.link='https://liveparty.com.br/iframeBase.html'*/
    }
    constructor( private fb : FormBuilder,public _appData : AppDataService,public _sanitizer: DomSanitizer,private _companyService : CompanyService) {
    }

}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/external-link-modal/external-link-modal.ts